import React from 'react';
import styled from 'styled-components';
import { useWorkspace } from '~/contexts';

const Description = styled.p`
  margin-top: 2rem;
`;

export default function BillingNotEnabled() {
  const { workspace } = useWorkspace();

  const { isSandbox, isRequired } = workspace.billing ?? {};
  const associatedName = workspace.billing?.associatedWorkspace?.name;

  // Sandbox workspace - friendly message with associated workspace name, no button
  if (isSandbox) {
    return (
      <Description>
        This is a sandbox workspace
        {associatedName && (
          <>
            {' '}
            for <strong>{associatedName}</strong>
          </>
        )}
        . Billing is not required.
      </Description>
    );
  }

  // Billing not required - show associated workspace if available, no button
  if (!isRequired) {
    if (associatedName) {
      return (
        <Description>
          Billing for this workspace is managed by <strong>{associatedName}</strong>.
        </Description>
      );
    }
    return <Description>Billing is not required for this workspace.</Description>;
  }

  return null;
}
